import {
  dotTypeColors,
  getColorByState,
  getStateOfNodeByType
} from 'components/scenarios/utils/graph-node-lifecycle'
import { hasRunPassed } from 'components/services/service-utils'
import { useGetSelectedRunFromRoute } from 'queries/reliability-tests/use-get-selected-run-from-route'

import type {
  FailureFlagNode,
  InfraAttackNode
} from 'types/api/scenarios/scenario'

export const useGetGraphNodeStatusColor = (
  node: InfraAttackNode | FailureFlagNode
) => {
  const { isHalted, isSuccessful, isFailed } = getStateOfNodeByType(node)
  const { data: selectedRun, isSuccess } = useGetSelectedRunFromRoute()

  // see EN-6291 for why we want to display a warning instead of an error for a failed InfraAttackNode in a successful RM run
  // we don't know if/when the same logic would apply to a FailureFlagNode, but keeping this just in case there is a future
  // case where the FailureFlagNode itself can fail but the RM run is still successful
  const isWarningInsteadOfError =
    isSuccess && hasRunPassed(selectedRun.run) && isFailed

  const statusBgColor = (() => {
    if (isFailed || isHalted || isSuccessful) {
      return isWarningInsteadOfError
        ? dotTypeColors.orange
        : getColorByState(node)
    }
  })()

  return {
    isWarningInsteadOfError,
    statusBgColor
  }
}
